import { useEffect, useMemo, useRef, useState } from 'react';

const useAutoScrollChat = () => {
  //--------------------AUTO SCROLL CHAT-----------------------------------------
  const chatContainer = useRef(null);
  const [autoScroll, setAutoScroll] = useState(true);
  const messageRefs = useRef({ byId: {}, byDate: {} }); // Refs for messages

  const handleScroll = () => {
    if (!chatContainer.current) return;
    // eslint-disable-next-line no-unsafe-optional-chaining
    const { scrollTop, scrollHeight, clientHeight } = chatContainer?.current;
    if (scrollHeight - scrollTop === clientHeight) {
      setAutoScroll(true);
    } else {
      setAutoScroll(false);
    }
  };

  useEffect(() => {
    const container = chatContainer.current;

    if (autoScroll && container) {
      container.scrollTop = container.scrollHeight + 100;
    }

    const handleUserScroll = () => {
      if (!container) return;
      const { scrollTop, scrollHeight, clientHeight } = container;
      const atBottom = scrollHeight - scrollTop === clientHeight;
      if (!atBottom) {
        setAutoScroll(false);
      }
    };

    if (container) {
      container.addEventListener('scroll', handleUserScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener('scroll', handleUserScroll);
      }
    };
  }, [autoScroll]);
  //------------------------------AUTO SCROLL CHAT----------------------------------------

  const handleScrollRequest = useMemo(() => {
    let lastScrollTime = 0;
    const scrollInterval = 500; // ms

    return (direction, amount) => {
      const now = Date.now();

      if (now - lastScrollTime > scrollInterval && chatContainer.current) {
        lastScrollTime = now;

        requestAnimationFrame(() => {
          chatContainer.current.scrollBy({
            top: direction * amount,
            behavior: 'smooth',
          });
        });
      }
    };
  }, []);

  const goToDown = () => {
    if (chatContainer && chatContainer.current) {
      const containerElement = chatContainer.current;
      const scrollPosition =
        containerElement.scrollHeight - containerElement.offsetHeight;

      const animateScroll = () =>
        containerElement.scrollTo({
          top: scrollPosition,
          behavior: 'auto',
        });

      requestAnimationFrame(animateScroll);
    }
  };

  const scrollToMessage = (identifier, isUserMessage, behavior = 'smooth') => {
    if (isUserMessage === null) {
      return;
    }

    const messageElement = isUserMessage
      ? messageRefs.current.byDate[identifier]
      : messageRefs.current.byId[identifier];

    if (messageElement && chatContainer.current) {
      const containerElement = chatContainer.current;
      const scrollPosition =
        messageElement.offsetTop - containerElement.offsetTop;

      const animateScroll = () =>
        containerElement.scrollTo({
          top: scrollPosition,
          behavior,
        });

      requestAnimationFrame(animateScroll);
    }
  };

  return {
    chatContainer,
    autoScroll,
    setAutoScroll,
    messageRefs,
    handleScroll,
    handleScrollRequest,
    goToDown,
    scrollToMessage,
  };
};

export default useAutoScrollChat;
